// components/CartShimmer.js
import React from "react";

// Shimmer for cart items
export const CartItemsShimmer = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
      {[1, 2, 3].map((item) => (
        <div key={item} className="flex items-center gap-4 p-4 border-b border-gray-100 last:border-0">
          <div className="w-20 h-20 flex-shrink-0">
            <div className="w-full h-full rounded-lg bg-gray-200 animate-pulse"></div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="h-5 bg-gray-200 rounded animate-pulse w-3/4 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2 mb-2"></div>
            <div className="h-6 bg-gray-200 rounded animate-pulse w-1/4"></div>
          </div>
          <div className="flex flex-col items-end gap-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gray-200 rounded-l-lg animate-pulse"></div>
              <div className="w-6 h-8 bg-gray-200 animate-pulse"></div>
              <div className="w-8 h-8 bg-gray-200 rounded-r-lg animate-pulse"></div>
            </div>
            <div className="h-5 bg-gray-200 rounded animate-pulse w-16"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

// Shimmer for order summary
export const OrderSummaryShimmer = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 sticky top-28">
      <div className="h-7 bg-gray-200 rounded animate-pulse w-40 mb-4"></div>
      <div className="space-y-3 border-b border-gray-200 pb-4">
        <div className="flex justify-between">
          <div className="h-5 bg-gray-200 rounded animate-pulse w-32"></div>
          <div className="h-5 bg-gray-200 rounded animate-pulse w-20"></div>
        </div>
        <div className="flex justify-between">
          <div className="h-5 bg-gray-200 rounded animate-pulse w-28"></div>
          <div className="h-5 bg-gray-200 rounded animate-pulse w-20"></div>
        </div>
        <div className="flex justify-between">
          <div className="h-5 bg-gray-200 rounded animate-pulse w-24"></div>
          <div className="h-5 bg-gray-200 rounded animate-pulse w-20"></div>
        </div>
        <div className="flex justify-between">
          <div className="h-5 bg-gray-200 rounded animate-pulse w-32"></div>
          <div className="h-5 bg-gray-200 rounded animate-pulse w-20"></div>
        </div>
      </div>
      <div className="mt-4">
        <div className="h-10 bg-gray-200 rounded animate-pulse w-full"></div>
      </div>
      <div className="mt-4">
        <div className="h-20 bg-gray-200 rounded animate-pulse w-full"></div>
      </div>
      <div className="mt-2">
        <div className="h-12 bg-gray-200 rounded animate-pulse w-full"></div>
      </div>
      <div className="flex justify-between py-4 mt-4 border-t border-gray-200">
        <div className="h-6 bg-gray-200 rounded animate-pulse w-20"></div>
        <div className="h-6 bg-gray-200 rounded animate-pulse w-24"></div>
      </div>
      <div className="h-12 bg-gray-200 rounded animate-pulse w-full mt-4"></div>
    </div>
  );
};

// Address shimmer
export const AddressShimmer = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3 flex-1">
          <div className="w-5 h-5 bg-gray-200 rounded animate-pulse mt-1"></div>
          <div className="flex-1">
            <div className="h-5 bg-gray-200 rounded animate-pulse w-32 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded animate-pulse w-48 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded animate-pulse w-24"></div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gray-200 rounded animate-pulse"></div>
          <div className="w-16 h-8 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

// Restaurant info shimmer
export const RestaurantShimmer = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-lg bg-gray-200 animate-pulse"></div>
        <div className="flex-1">
          <div className="h-5 bg-gray-200 rounded animate-pulse w-48 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded animate-pulse w-32"></div>
        </div>
      </div>
    </div>
  );
};

// Tab shimmer
export const TabShimmer = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-1 mb-6 flex gap-1">
      <div className="flex-1 py-3 px-4 rounded-lg bg-gray-200 animate-pulse h-12"></div>
      <div className="flex-1 py-3 px-4 rounded-lg bg-gray-200 animate-pulse h-12"></div>
    </div>
  );
};

// Header shimmer
export const HeaderShimmer = () => {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-4">
        <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse"></div>
        <div className="h-8 bg-gray-200 rounded animate-pulse w-32"></div>
        <div className="h-6 bg-gray-200 rounded-full animate-pulse w-16"></div>
      </div>
      <div className="h-6 bg-gray-200 rounded animate-pulse w-20"></div>
    </div>
  );
};